import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getAllBrandsWithAllModules } from "../api/getAllBrandsWithAllModules";
import { ContentSchedule } from "../types";

export const ALL_BRANDS_MODULES_QUERY_KEY = ["allBrandsModules"];

export const useAllBrandsWithAllModulesQuery = () => {
  return useQuery({
    queryKey: ALL_BRANDS_MODULES_QUERY_KEY,
    queryFn: () => getAllBrandsWithAllModules(),
    select: (data) => data,
  });
};

export const getAllBrandsWithAllModulesQueryData = (): ContentSchedule[] => {
  const data = queryClient.getQueryData<ContentSchedule[]>(
    ALL_BRANDS_MODULES_QUERY_KEY,
  );

  return data || [];
};

export const setAllBrandsWithAllModulesQueryData = (
  data: ContentSchedule[],
) => {
  queryClient.setQueryData(ALL_BRANDS_MODULES_QUERY_KEY, data);
};

export const invalidateAllBrandsWithAllModulesQuery = async () => {
  await queryClient.invalidateQueries({
    queryKey: ALL_BRANDS_MODULES_QUERY_KEY,
  });
};
